import AABB3 from '../math/AABB3';
import Renderer from '../rendering/Renderer';
import { ShaderProgram } from '../rendering/Shader';

interface binders {
	[binderID: string]: WebGLBuffer;
};

export default abstract class Mesh3D {
	aabb: AABB3;
	vertexCount: number;
	vertexBuffer: ArrayBuffer;
	// indexBuffer: Uint16Array;
	bufferBinders: Array<binders>;

	constructor (geometry) {
		this.vertexCount = 0;
		this.aabb = new AABB3(new Float32Array([Infinity, -Infinity, Infinity, -Infinity, Infinity, -Infinity]));

		this.bufferBinders = [];
		this.vertexBuffer = new ArrayBuffer(0);
		// this.indexBuffer = new Uint16Array(0);
		
		this.updateGeometry(geometry);
	}

	updateGeometry (geometry) {
		this.createVertexBuffer(geometry);

		// Constructing the bounding box enclosing the mesh
		const positions = geometry.positions;
		for (let p = 0; p < positions.length; p += 1) {
			this.aabb.expands(positions[p]);
		}
		this.aabb.updateVolume();
	}

	abstract createVertexBuffer(geometry: any): void

	abstract render (renderer: Renderer, program: ShaderProgram, withNormals: boolean): void

	uploadVertexBuffers (renderer: Renderer) {
		var gl = renderer.gl;
		const vertexBufferBinder = gl.createBuffer();
		gl.bindBuffer(gl.ARRAY_BUFFER, vertexBufferBinder);
		gl.bufferData(gl.ARRAY_BUFFER, this.vertexBuffer, gl.STATIC_DRAW);

		// const indexBufferBinder = gl.createBuffer();
		// gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBufferBinder);
		// gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer, gl.STATIC_DRAW);

		if (vertexBufferBinder === null/* || indexBufferBinder === null*/) {
			throw new Error('oops, cannot create vertex buffers');
		}

		return this.bufferBinders[renderer.id] = {
			vertex: vertexBufferBinder,
			// index: indexBufferBinder
		};
	}

	// delete () {
	// 	if (this._vertexBufferBinder) {
	// 		renderer.gl.deleteBuffer(this._vertexBufferBinder);
	// 		this._vertexBufferBinder = null;
	// 	}

	// 	if (this._indexBufferBinder) {
	// 		renderer.gl.deleteBuffer(this._indexBufferBinder);
	// 		this._indexBufferBinder = null;
	// 	}
	// }
}
